// Setup › People and Setup › Roles (design spec §9 "People & roles", split in two routes so each
// has its own sidebar row): features/settings/people.tsx and roles.tsx.
import { createRoute } from "@tanstack/react-router";
import { PeopleScreen } from "../features/settings/people";
import { RolesScreen } from "../features/settings/roles";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { setupRoute } from "./c.$slug.setup";

export const setupPeopleRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "people",
  // SEARCH-NOTIF: `?invite=1` (⌘K "Invite person") opens the invite dialog.
  validateSearch: (search: Record<string, unknown>) => ({
    ...validateFocusSearch(search),
    ...(search.invite === "1" || search.invite === 1 ? { invite: "1" as const } : {}),
  }),
  component: function People() {
    const { api } = setupPeopleRoute.useRouteContext();
    const { invite } = setupPeopleRoute.useSearch();
    return <PeopleScreen api={api} company={useCompany()} invite={invite === "1"} />;
  },
});

export const setupRolesRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "roles",
  component: function Roles() {
    const { api } = setupRolesRoute.useRouteContext();
    return <RolesScreen api={api} company={useCompany()} />;
  },
});
